"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.injectStopPropagation = exports.styleLinkText = exports.styleLabelText = exports.defaultSmsOptIn = exports.defaultTermsAndPrivacyOptIn = exports.buildSurveyConfigOptIns = void 0;
// existing surveys might not have the opt in fields in the builder, so handle gracefully and fall
// back to defaults if they don't exist
const buildSurveyConfigOptIns = (builderConfig) => {
    var _a, _b;
    const hasRequiredDefaultOptIns = ((_b = (_a = builderConfig.optIns) === null || _a === void 0 ? void 0 : _a.filter((optIn) => optIn.id === "optInTermsPrivacy1" || optIn.id === "optInText")) === null || _b === void 0 ? void 0 : _b.length) === 2;
    const optinOptions = hasRequiredDefaultOptIns
        ? [...builderConfig.optIns]
        : // this handles existing surveys that don't have these
            [
                (0, exports.defaultTermsAndPrivacyOptIn)(builderConfig.artistName),
                (0, exports.defaultSmsOptIn)(builderConfig.artistName),
            ];
    if (builderConfig.fields.useCustomTermsAndPrivacyPolicy.content) {
        const optInTermsPrivacyIndex = optinOptions.findIndex((opt) => opt.id === "optInTermsPrivacy1");
        optinOptions[optInTermsPrivacyIndex] = {
            id: "optInTermsPrivacy1",
            htmlLabel: builderConfig.fields.customTermsAndPrivacyPolicy.content.en,
            required: true,
        };
        // if separate line items, insert after opt in terms and privacy
        if (builderConfig.fields.termsAndPrivacyPolicySeparateLineItems.content.en) {
            optinOptions.splice(optInTermsPrivacyIndex + 1, 0, {
                id: "optInTermsPrivacy2",
                htmlLabel: (0, exports.styleLabelText)(builderConfig.fields.termsAndPrivacyPolicySeparateLineItems.content
                    .en),
                required: true,
            });
        }
    }
    if (builderConfig.fields.useCustomSmsOptIn.content) {
        const optInSmsIndex = optinOptions.findIndex((opt) => opt.id === "optInText");
        const optInLabelOverride = builderConfig.fields.customSmsOptIn.content.en;
        if (optInLabelOverride) {
            optinOptions[optInSmsIndex] = {
                id: "optInText",
                htmlLabel: optInLabelOverride,
            };
        }
    }
    if (builderConfig.fields.phoneNumberValidation.content === "no-phone") {
        const optInSmsIndex = optinOptions.findIndex((opt) => opt.id === "optInText");
        if (optInSmsIndex !== -1) {
            optinOptions.splice(optInSmsIndex, 1);
        }
    }
    return {
        type: "confirm",
        validation: {
            type: "require_all",
            message: "Please agree to the terms to submit your feedback",
            all: optinOptions
                .filter((optIn) => optIn.required)
                .map((optIn) => optIn.id),
        },
        id: "optIn",
        options: optinOptions,
    };
};
exports.buildSurveyConfigOptIns = buildSurveyConfigOptIns;
const defaultTermsAndPrivacyOptIn = (artistName) => ({
    id: "optInTermsPrivacy1",
    htmlLabel: `<div style="font-size:12px;line-height:18px;font-family:'Poppins';">
I agree to share the above information with <span style="font-weight: 800">${artistName}</span>
and <span style="font-weight: 800">Set.Live</span>. I agree to SET's <a style="color: #006ACC" onclick="(function(e){ const event = new Event('setfan-show-terms',{bubbles: true});e.target.dispatchEvent(event); e.stopPropagation();return false;})(arguments[0]);return false;">
Terms of Use</a> and <a style="color: #006ACC" onclick="(function(e){const event = new Event('setfan-show-privacy',{bubbles: true});e.target.dispatchEvent(event);e.stopPropagation();return false;})(arguments[0]);return false;">
 Privacy Policy
</a></div>`,
    required: true,
});
exports.defaultTermsAndPrivacyOptIn = defaultTermsAndPrivacyOptIn;
const defaultSmsOptIn = (artistName) => ({
    id: "optInText",
    htmlLabel: `<div style="font-size:12px;line-height:18px;font-family:'Poppins';">
    I’d like to receive text or messaging service messages from ${artistName}, SET,
     or via ${artistName}’s partners or representatives. Consent is not a condition of purchase.
     Message data rates may apply.
   </div>`,
});
exports.defaultSmsOptIn = defaultSmsOptIn;
// default text styling for checkbox labels in the SET.Fan fan app
const styleLabelText = (text) => `<span style="font-size:12px;line-height:18px;font-family:'Poppins';">${text}</span>`;
exports.styleLabelText = styleLabelText;
const styleLinkText = ({ href, text, }) => `<a href=${href} ${STOP_PROPAGATION} style="color:#006ACC;text-decoration:none;" target="__blank">${text}</a>`;
exports.styleLinkText = styleLinkText;
// when a user clicks a link in an opt in in the SET.Fan fan app, we do not want the option
// selected.
const STOP_PROPAGATION = `onclick="(function(e){ e.stopPropagation();})(arguments[0]);"`;
const injectStopPropagation = (text) => text.replace(/(a) (href)/g, `$1 ${STOP_PROPAGATION} style="color:#006ACC;" $2`);
exports.injectStopPropagation = injectStopPropagation;
//# sourceMappingURL=optIns.js.map